import React, { useState, useEffect } from 'react';

const defaultMessages = ['Please check your internet connection.', 'Your browser has lost connection to the internet.'];

const checkInternet = () => {
  if (typeof window === 'undefined') {
    return true;
  } else {
    return window.navigator.onLine;
  }
};

const getRandomItem = (list: any[]) => {
  return list[Math.floor(Math.random() * list.length)];
};

type Props = {
  messages?: string[];
  images?: string[];
  styles?: React.CSSProperties;
};

export function NetworkStatus({ messages = defaultMessages, styles }: Props) {
  const [isOnline, setIsOnline] = useState(checkInternet());
  const [message, setMessage] = useState('');

  const defaultStyles: React.CSSProperties = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    zIndex: 9999,
    borderRadius: '8px',
    padding: '32px',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    fontFamily: 'Arial, sans-serif',
    color: '#333',
    maxWidth: '80%',
    maxHeight: '80vh',
    overflow: 'auto',
    background: '#aaa', // Fallback background color
    backgroundColor: 'linear-gradient(135deg, #888 0%, #aaa 100%)', // Standard linear gradient
  };

  useEffect(() => {
    const handleConnectionChange = () => {
      const isConnected = checkInternet();
      setIsOnline(isConnected);

      if (!isConnected) {
        setMessage(getRandomItem(messages));
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('offline', handleConnectionChange);
      window.addEventListener('online', handleConnectionChange);

      return () => {
        window.removeEventListener('offline', handleConnectionChange);
        window.removeEventListener('online', handleConnectionChange);
      };
    }
  }, []);

  if (!isOnline) {
    return (
      <div style={{ ...defaultStyles, ...styles }}>
        <p
          style={{
            fontSize: '18px',
            fontWeight: 500,
            lineHeight: '24px',
            marginTop: 0,
            marginBottom: 0,
          }}
        >
          {message}
        </p>
      </div>
    );
  }

  return null;
}
